import { render, staticRenderFns } from "./BaseLocaleSwitcher.vue?vue&type=template&id=0c4454e1&scoped=true&"
import script from "./BaseLocaleSwitcher.vue?vue&type=script&lang=js&"
export * from "./BaseLocaleSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./BaseLocaleSwitcher.vue?vue&type=style&index=0&id=0c4454e1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4454e1",
  null
  
)

export default component.exports